const defaultApiRoute = "https://remaxterizado_api.test/api";
// const defaultApiRoute = "https://api.remaxterizado.es/api";

export default {
    defaultApiRoute: defaultApiRoute,
};
